import { render, staticRenderFns } from "./ProjectRequests.vue?vue&type=template&id=48975f19&"
import script from "./ProjectRequests.vue?vue&type=script&lang=js&"
export * from "./ProjectRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports